import { coreV1GetTransformOptions } from '@antimatterhq/asl-api-ts-v1';
import { useSuspenseQuery } from '@antimatterhq/ui/hooks/queries/useSuspenseQuery';
import { useValueWithSuspense } from '@antimatterhq/ui/hooks/suspense/useValueWithSuspense';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';

export const useGetTransformSuspense = ({ name }: { name: string }) => {
  const workspaceContext = useWorkspace();
  const workspace = useValueWithSuspense(workspaceContext.workspace);

  return useSuspenseQuery({
    ...coreV1GetTransformOptions({
      ...defaultOptions(),
      path: { workspace, name },
    }),
    gcTime: 1,
  });
};
